module.exports = __webpack_public_path__ + "fonts/line.567f57385ea3dde2c9aec797d07850d2.gif?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/line.gif
// module id = 339
// module chunks = 6